import { WEB_SERVICE_MIMS } from "./constants";
import UseFetch from "./useFetch";

const checkHospitalInProject = async (hospitalName, project) => {
  if (!hospitalName) return false;
  const { data } = await UseFetch("get", `${WEB_SERVICE_MIMS}/hospitals/by-project/${project}`);
  const hospitals = new Set(data.map((hospital) => hospital.HOSPITAL_NAME));
  return hospitals.has(hospitalName);
};

export const isPhraseProjectHospital = async (hospitalName) => {
  return await checkHospitalInProject(hospitalName, "PHRASE");
};

export const isNestProjectHospital = async (hospitalName) => {
  return await checkHospitalInProject(hospitalName, "NEST");
};

export const isRGSICUProjectHospital = async (hospitalName) => {
  return await checkHospitalInProject(hospitalName, "RGS_ICU");
};

export const isAISNProjectHospital = async (hospitalName) => {
  return await checkHospitalInProject(hospitalName, "AISN");
};
